import { render, staticRenderFns } from "./ScoreFactor.vue?vue&type=template&id=cde91546&scoped=true"
import script from "./ScoreFactor.vue?vue&type=script&lang=js"
export * from "./ScoreFactor.vue?vue&type=script&lang=js"
import style0 from "./ScoreFactor.vue?vue&type=style&index=0&id=cde91546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde91546",
  null
  
)

export default component.exports